import { render, staticRenderFns } from "./MoleculeGuidedTourTimeline.vue?vue&type=template&id=0b158cd8&scoped=true&"
import script from "./MoleculeGuidedTourTimeline.vue?vue&type=script&lang=js&"
export * from "./MoleculeGuidedTourTimeline.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeGuidedTourTimeline.vue?vue&type=style&index=0&id=0b158cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b158cd8",
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismGuidedTourTimeline.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2Fbuilding%2FMoleculeGuidedTourTimeline.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports